import React from 'react'
import styles from './MicrositeStatusFilter.module.css'

/**
 * MicrositeStatusFilter
 * Pill-style tab row for filtering a list by status. Used on
 * Custom Pages and Blog list screens (All / Draft / Published /
 * Scheduled).
 *
 * Usage:
 *   <MicrositeStatusFilter
 *     value={statusFilter}
 *     onChange={setStatusFilter}
 *     options={[
 *       { value: '', label: 'All' },
 *       { value: 'draft', label: 'Draft' },
 *       { value: 'published', label: 'Published' },
 *       { value: 'scheduled', label: 'Scheduled' }
 *     ]}
 *   />
 */
const MicrositeStatusFilter = ({ value, onChange, options = [] }) => (
    <div className={styles.tabs}>
        {options.map((opt) => (
            <button
                key={opt.value}
                type="button"
                className={`${styles.tab} ${value === opt.value ? styles.tabActive : ''}`}
                onClick={() => onChange?.(opt.value)}
            >
                {opt.label}
                {opt.count !== undefined && <span className={styles.count}>{opt.count}</span>}
            </button>
        ))}
    </div>
)

export default MicrositeStatusFilter